'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Strings = require('./utility/Strings');

var _Strings2 = _interopRequireDefault(_Strings);

var _Constants = require('./Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 版本对象
 * 
 * @export
 * @class Version
 */
var Version = function () {

    /**
     * 创建一个版本
     * 
     * @ignore
     * @param {string} version 版本字符串
     * @memberof Version
     */
    function Version(version) {
        (0, _classCallCheck3.default)(this, Version);

        if (!version) {
            version = '';
        }

        this.rawVersion = version;
        this.compare = this.compare.bind(this);
        this.parse = this.parse.bind(this);

        this.parse(version);

        this._version = this.major + '.' + this.minor + '.' + this.revision;
    }

    /**
     * 主版本
     * 
     * @type {number}
     * @readonly
     * @memberof Version
     */


    (0, _createClass3.default)(Version, [{
        key: 'parse',
        value: function parse(versionString) {
            if (!_Strings2.default.hasText(versionString)) {
                versionString = _Constants2.default.defaultVersion;
                this._major = 0;
                this._minor = 0;
                this._revision = 0;
            } else {
                var wrongVersionError = new Error('The version ' + versionString + ' is not correct version.');
                var versionParts = versionString.split('.');
                if (versionParts.length >= 4) {
                    throw wrongVersionError;
                }

                this._major = parseInt(versionParts[0]);

                if (isNaN(this._major)) {
                    throw wrongVersionError;
                }

                if (versionParts.length >= 2) {
                    this._minor = parseInt(versionParts[1]);
                } else {
                    this._minor = 0;
                }

                if (isNaN(this._minor)) {
                    throw wrongVersionError;
                }

                if (versionParts.length >= 3) {
                    this._revision = parseInt(versionParts[2]);
                } else {
                    this._revision = 0;
                }

                if (isNaN(this._revision)) {
                    throw wrongVersionError;
                }
            }
        }

        /**
         * 比较版本
         * 
         * @param {Version} otherVersion 另一个版本对象
         * @returns {number} 如果大于另一个版本，则返回1；如果相等，返回0；否则返回-1
         * @memberof Version
         */

    }, {
        key: 'compare',
        value: function compare(otherVersion) {
            if (!otherVersion || (typeof otherVersion === 'undefined' ? 'undefined' : (0, _typeof3.default)(otherVersion)) !== 'object') {
                return 1;
            }

            if (this.major !== otherVersion.major) {
                return this.major - otherVersion.major > 0 ? 1 : -1;
            }

            if (this.minor !== otherVersion.minor) {
                return this.minor - otherVersion.minor > 0 ? 1 : -1;
            }

            var result = this.revision - otherVersion.revision;

            return result > 0 ? 1 : result === 0 ? 0 : -1;
        }

        /**
         * 解析版本
         * 
         * @static
         * @param {string} versionString 版本字符串
         * @returns {Version} 解析结果版本对象
         * @memberof Version
         */

    }, {
        key: 'major',
        get: function get() {
            return this._major;
        }

        /**
         * 次版本
         * 
         * @type {number}
         * @readonly
         * @memberof Version
         */

    }, {
        key: 'minor',
        get: function get() {
            return this._minor;
        }

        /**
         * 修订版本
         * 
         * @type {number}
         * @readonly
         * @memberof Version
         */

    }, {
        key: 'revision',
        get: function get() {
            return this._revision;
        }

        /**
         * 版本原始格式
         * 
         * @readonly
         * @memberof Version
         */

    }, {
        key: 'versionString',
        get: function get() {
            return this._version;
        }
    }], [{
        key: 'parse',
        value: function parse(versionString) {
            return new Version(versionString);
        }
    }]);
    return Version;
}();

exports.default = Version;
//# sourceMappingURL=Version.js.map